import Vue from "vue";

import vueAttributeCheckable from "./mixins/vue-attribute-checkable";

Vue.mixin(vueAttributeCheckable);
